import React from "react";
import logo from "../../asset/logo.svg";
import { ReactSVG } from "react-svg";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

export const sidebarlist = [
  {
    name: "Banners",
    path: "/icon/banners.svg",
    link: "/banners",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Projects",
    path: "/icon/Projects.svg",
    link: "/projects",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Housing Societies",
    path: "/icon/Housing Scocieties.svg",
    link: "/housing-societies",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Blogs",
    path: "/icon/Blogs.svg",
    link: "/blogs",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Add User",
    path: "/icon/add user 1.svg",
    link: "/users",
    allowedRoles: ["admin"],
  },
  {
    name: "Management",
    path: "/icon/Management.svg",
    link: "/management",
    allowedRoles: ["admin"],
  },
  {
    name: "Press Release",
    path: "/icon/Press Release.svg",
    link: "/press-release",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Careers",
    path: "/icon/Careers.svg",
    link: "/careers",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Tenders",
    path: "/icon/Tenders.svg",
    link: "/tenders",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Auctions",
    path: "/icon/auction.svg",
    link: "/auctions",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Media",
    path: "/icon/Media.svg",
    link: "/media",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Downloads",
    path: "/icon/Downloads.svg",
    link: "/downloads",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Announcement",
    path: "/icon/Announcement.svg",
    link: "/announcement",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Public Notices",
    path: "/icon/publicNotice.svg",
    link: "/public-notices",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Announcement Popup",
    path: "/icon/popUp.svg",
    link: "/announcement-popup",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Latest News",
    path: "/icon/latestNews.svg",
    link: "/latest-news",
    allowedRoles: ["admin", "mediaTeam"],
  },
   {
    name: "Partners",
    path: "/icon/partner.svg",
    link: "/partners",
    allowedRoles: ["admin", "mediaTeam"],
  },
];
const Sidebar = () => {
  const userRole = useSelector((state) => state.auth.user?.role);
  const visibleLinks = sidebarlist.filter((item) =>
    item.allowedRoles.includes(userRole),
  );
  return (
    <aside className="md:flex hidden flex-col md:p-4 p-1  gap-3 lg:w-[280px] w-[220px]  fixed top-[0px] bottom-0 z-40 h-screen bg-white">
      <img src={logo} className="lg:w-20 w-16" alt="" />
      <div className=" overflow-y-auto customScrollbar pr-1">
        <span className="text-[#00000052] uppercase text-[.9rem] md:flex hidden">
          Main
        </span>
        <div className="flex flex-col md:mt-3 w-max ">
          {visibleLinks.map((list, i) => (
            <NavLink
              to={list.link}
              key={i}
              className={({ isActive }) =>
                `flex items-center md:gap-3 px-2 lg:py-4 md:py-3 py-2 rounded-xl lg:text-[1.1rem] text-[.8rem] font-medium transition-all ${
                  isActive
                    ? "bg-[#00643b] text-white"
                    : "text-[#666666] hover:bg-[#f3f3f3]"
                }`
              }
            >
              <ReactSVG src={list.path} className={`lg:w-6 w-5`} />
              <span className="md:flex hidden">{list.name}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
